import { Injectable, inject } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

import { DecodedToken } from '@cure-common/interfaces';

import { StorageService } from '../storage';

@Injectable({ providedIn: 'root' })
export class JwtService {
  private readonly storageService = inject(StorageService);

  decode<T>(): T | null {
    const token = this.storageService.getToken();
    return token ? jwtDecode<T>(token) : null;
  }

  getRoleFromToken(): string | null {
    const decode = this.decode<DecodedToken>();
    return decode?.role ?? null;
  }
}
